import { makeStyles } from '@material-ui/core/styles';
export const useFormExportStyles = makeStyles(theme => ({
  form: {
    flexGrow: 1
  },
  tooltipWrapper: {
    width: '50%'
  }
}));
